export class XPayJwtTokenRequest {
  public publisherId: number;
  public countryCode: string;
}
